<template>
<div class="content-wrapper">
  <div :class="contentClass">
    <el-scrollbar v-if="defaultContent === true" class="bar-visible">
      <div class="tab-content">
        <slot name="content" />
      </div>
    </el-scrollbar>
    <slot v-else name="content"/>
  </div>
  <div v-if="$slots.footer !== undefined" class="content-footer el-dialog__footer">
    <slot name="footer" />
  </div>
</div>
</template>

<script>
export default {
  name: 'WFramePopupContentTemplate',
  props: {
    defaultContent: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    contentClass() {
      return this.$slots.footer === undefined ? 'content-no-footer' : 'content-include-footer';
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/FramePopupContentTemplate.vue